import { useEffect } from 'react';
import { Spinner } from 'components';
import { useNavigate } from 'react-router-dom';
import { usePaymentSuccessQuery } from '../../hooks';

export const PaymentReturn = () => {
  const navigate = useNavigate();
  const successState = usePaymentSuccessQuery();

  useEffect(() => {
    navigate &&
      successState &&
      navigate(
        { pathname: '/claims/shortfall/settle/paymentSuccess' },
        {
          state: successState,
        },
      );
  }, [navigate, successState]);

  return <Spinner />;
};
